package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.AppleSimpleIcons: ImageVector
    get() {
        if (_appleSimpleIcons != null) {
            return _appleSimpleIcons!!
        }
        _appleSimpleIcons = Builder(name = "AppleSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.15f, 6.90f)
                curveToRelative(-0.95f, 0.0f, -2.42f, -1.08f, -3.96f, -1.04f)
                curveToRelative(-2.04f, 0.03f, -3.91f, 1.18f, -4.96f, 3.01f)
                curveToRelative(-2.12f, 3.68f, -0.55f, 9.10f, 1.52f, 12.09f)
                curveToRelative(1.01f, 1.45f, 2.21f, 3.09f, 3.79f, 3.04f)
                curveToRelative(1.52f, -0.07f, 2.09f, -0.99f, 3.94f, -0.99f)
                curveToRelative(1.83f, 0.0f, 2.35f, 0.99f, 3.96f, 0.95f)
                curveToRelative(1.64f, -0.03f, 2.68f, -1.48f, 3.68f, -2.95f)
                curveToRelative(1.16f, -1.69f, 1.64f, -3.33f, 1.66f, -3.42f)
                curveToRelative(-0.04f, -0.01f, -3.18f, -1.22f, -3.22f, -4.86f)
                curveToRelative(-0.03f, -3.04f, 2.48f, -4.49f, 2.60f, -4.56f)
                curveToRelative(-1.43f, -2.09f, -3.62f, -2.32f, -4.39f, -2.38f)
                curveToRelative(-2.0f, -0.16f, -3.68f, 1.09f, -4.61f, 1.09f)
                close()
                moveTo(15.53f, 3.83f)
                curveToRelative(0.84f, -1.01f, 1.4f, -2.43f, 1.25f, -3.83f)
                curveToRelative(-1.21f, 0.05f, -2.66f, 0.81f, -3.53f, 1.82f)
                curveToRelative(-0.78f, 0.90f, -1.45f, 2.34f, -1.27f, 3.71f)
                curveToRelative(1.34f, 0.10f, 2.72f, -0.69f, 3.56f, -1.70f)
            }
        }
        .build()
        return _appleSimpleIcons!!
    }

private var _appleSimpleIcons: ImageVector? = null
